<template>
  <b-modal
    id="edit-modal"
    :visible="visible"
    @hide="closeModal()"
    hide-footer
    title="Edit Commission Split"
    centered
  >
  <div class="mb-3">
    <label for="" class="mb-2">Seller Rep <span class="required">*</span></label>
    <multiselect
              id=""
              v-model="seller_agent"
              :options="repList"
              :searchable="true"
              :show-labels="true"
              placeholder="Select Seller Rep"
              class="form-select-custom"
              :class="{ 'is-invalid': errors.seller_agent }"
              :allow-empty="false"
              :close-on-select="true"
              :max-height="250"
              label="agent_name"
              track-by="agent_id"
              @input="clearError('seller_agent')"
            />
            <div v-if="errors.seller_agent" class="text-danger small">{{ errors.seller_agent }}</div>
  </div>

  <div class="row">
    <div class="col-md-6 mb-3">
      <label for="" class="mb-2">Split From.</label><br>
      <div class="from-rep">Brent </div>
    </div>
    <div class="col-md-6 mb-3">
      <label for="" class="mb-2">Split To.</label>
      <div class="from-rep">Tyler</div>
    </div>
  </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="" class="mb-2">From % <span class="required">*</span></label>
          <input
            type="number"
            placeholder="50"
            class="form-control form-input ml-0"
            :class="{ 'is-invalid': errors.split_from_comm }"
            v-model.number="form.split_from_comm"
            @input="updateFromSplit"
            min="0"
            max="100"
            step="1"
          />
          <div v-if="errors.split_from_comm" class="text-danger small">{{ errors.split_from_comm }}</div>
        </div>
        <div class="col-md-6 mb-3">
          <label for="" class="mb-2">To % <span class="required">*</span></label>
          <input
            type="number"
            placeholder="50"
            class="form-control form-input ml-0"
            :class="{ 'is-invalid': errors.split_to_comm }"
            v-model.number="form.split_to_comm"
            @input="updateToSplit"
            min="0"
            max="100"
            step="1"
          />
          <div v-if="errors.split_to_comm" class="text-danger small">{{ errors.split_to_comm }}</div>
        </div>
        <div class="col-md-6 mb-3">
          <label for="" class="mb-2">Effective Date <span class="required">*</span></label>
          <b-form-datepicker
            v-model="form.effective_date"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            :min="minDate"
            :max="maxDate"
            :date-disabled-fn="isDateDisabled"
            placeholder="Select Eff. Date"
            class="form-control form-input ml-0"
            :class="{ 'is-invalid': errors.effective_date }"
            @input="clearError('effective_date')"
          />
          <div v-if="errors.effective_date" class="text-danger small">{{ errors.effective_date }}</div>
        </div>
        <div class="col-md-6 mb-3">
          <label for="" class="mb-2">Status<span class="required">*</span></label>
          <select name=""  class="form-select shadow-none" v-model="form.isActive">
            <option value="1">Enable</option>
            <option value="0">Disable</option>
          </select>
        </div>
        <div class="col-md-12">
              <label for="" class="mb-2">Edit Reason<span class="required">*</span></label>
              <br />
              <textarea
                v-model="reason"
                name=""
                id=""
                rows="5"
                placeholder="Reason for the editing of the Commission Split"
                class="form-control form-input"
                :class="{ 'is-invalid': errors.reason }"
                @input="clearError('reason')"
              ></textarea>
              <div v-if="errors.reason" class="text-danger small">{{ errors.reason }}</div>
        </div>
      </div>
    </div>
     <div class="d-flex justify-content-end mt-3 gap-2">
       <b-button variant="secondary" @click="closeModal">Close</b-button>
       <b-button variant="primary" class="univ-btn m-0 p-0 w-fit" @click="submitForm">Add</b-button>
    </div>
  </b-modal>
</template>

<script>
import Helper from "@/resource/Helper"
import axios from "axios";

let default_form = {
      split_from_agent_id: 605,//Brent
      split_to_agent_id: 102741,//Tyler
      seller_agent_id: '',
      split_from_comm: 50,
      split_to_comm: 50,
      split_from_comm_type: "%",
      split_to_comm_type: "%",
      selected_key: "",
      selected_value: "",
      effective_date: "",
      isActive: 1,
    }

export default {
  name: "EditComm",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: default_form,
      reason: '',
      seller_agent: {},
      repList: [],
      errors: {
        seller_agent: '',
        split_from_comm: '',
        split_to_comm: '',
        effective_date: '',
        reason: ''
      }
    };
  },
  methods: {
    updateFromSplit() {
      this.clearError('split_from_comm');
      this.clearError('split_to_comm');
      
      if (this.form.split_from_comm === '' || isNaN(this.form.split_from_comm)) {
        return;
      }
      
      const fromValue = parseFloat(this.form.split_from_comm);
      if (fromValue >= 0 && fromValue <= 100) {
        this.form.split_to_comm = (100 - fromValue).toFixed(0);
      }
    },
    updateToSplit() {
      this.clearError('split_from_comm');
      this.clearError('split_to_comm');
      
      if (this.form.split_to_comm === '' || isNaN(this.form.split_to_comm)) {
        return;
      }
      
      const toValue = parseFloat(this.form.split_to_comm);
      if (toValue >= 0 && toValue <= 100) {
        this.form.split_from_comm = (100 - toValue).toFixed(0);
      }
    },
    isDateDisabled(ymd, date) {
      if (date.getDate() !== 1) {
        return true;
      }
      const today = new Date();
      const selectedDate = new Date(ymd);
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth();
      
      let prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
      let prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;
      
      if (selectedDate < new Date(prevYear, prevMonth, 1)) {
        return true;
      }
      
      return false;
    },
    async getRepList(){
      let loader = this.$loading.show();
        const config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Commission-Token': Helper.commissionRepToken()
        }
      };
      await axios.get(
        `${Helper.commissionUrl()}v1/rep/getDownlineAgents/605`,
        config
      ).then(({ data:{data} }) => {
        this.repList = data
      }).catch((error) => {
        console.log(error);
        this.$toast.error('Something went wrong. Please try again later.');
      }).finally(() => {
        loader.hide();
      });
    },
    validateForm() {
      let isValid = true;
      this.errors = {
        seller_agent: '',
        split_from_comm: '',
        split_to_comm: '',
        effective_date: '',
        reason: ''
      };

      if (!this.seller_agent || !this.seller_agent.agent_id) {
        this.errors.seller_agent = 'Seller Rep is required';
        isValid = false;
      }

      if (!this.form.split_from_comm) {
        this.errors.split_from_comm = 'From % is required';
        isValid = false;
      } else if (isNaN(this.form.split_from_comm) || this.form.split_from_comm < 0 || this.form.split_from_comm > 100) {
        this.errors.split_from_comm = 'Please enter a valid percentage between 0 and 100';
        isValid = false;
      }

      if (!this.form.split_to_comm) {
        this.errors.split_to_comm = 'To % is required';
        isValid = false;
      } else if (isNaN(this.form.split_to_comm) || this.form.split_to_comm < 0 || this.form.split_to_comm > 100) {
        this.errors.split_to_comm = 'Please enter a valid percentage between 0 and 100';
        isValid = false;
      }

      const fromValue = parseFloat(this.form.split_from_comm);
      const toValue = parseFloat(this.form.split_to_comm);
      let sum = Math.round((fromValue + toValue) * 100) / 100; 
      sum = parseInt(sum);
      
      if (sum !== 100) {
        this.errors.split_from_comm = 'Sum of From % and To % must be 100';
        this.errors.split_to_comm = 'Sum of From % and To % must be 100';
        isValid = false;
      }

      if (!this.reason) {
        this.errors.reason = 'Edit reason is required';
        isValid = false;
      } else if (this.reason.length < 10) {
        this.errors.reason = 'Edit reason must be at least 10 characters';
        isValid = false;
      }

      if (!this.form.effective_date) {
        this.errors.effective_date = 'Effective Date is required';
        isValid = false;
      }

      return isValid;
    },

    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = '';
      }
    },

    async submitForm(){
      if (!this.validateForm()) {
        return;
      }
      
      let loader = this.$loading.show();
      this.form.seller_agent_id = this.seller_agent.agent_id;
      this.form.updated_by = this.repId;
      this.form.reason = this.reason;
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Commission-Token': Helper.commissionRepToken()
        }
      };
      await axios.post(
        `${Helper.commissionUrl()}v1/rep/updateSpecialCommission/${this.data.id}`,
        this.form,
        config
      ).then(() => {
        Helper.infoMessage(this, 'success', 'Commission split updated successfully.');
        this.closeModal();
        this.$emit('reload');
      }).catch((error) => {
        if(error.response.status >= 500){
          Helper.infoMessage(this, 'error', 'Something went wrong. Please try again later.');
          return;
        }
        let message = error.response.data.message;
        let {errors} =  error.response.data
        Helper.infoMessage(this, 'error', message);
        let errs = Object.values(errors).flat();
        errs.forEach(err => {
          Helper.infoMessage(this, 'error', err);
        });
      }).finally(() => {
        loader.hide();
      });
    },
    closeModal() {
      this.$emit('close');
      this.resetForm();
    },
    resetForm(){
      this.form = JSON.parse(JSON.stringify(default_form));
      this.seller_agent = '';
      this.reason = '';
      this.errors = {
        seller_agent: '',
        split_from_comm: '',
        split_to_comm: '',
        effective_date: '',
        reason: ''
      };
      // this.form.effective_date = this.formatDate(this.minDate);
    },
    formatDate(date) {
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },
    
  },
  mounted() { 
    this.getRepList();
    // this.$nextTick(() => {
    //   this.form.effective_date = this.formatDate(this.minDate);
    // });
  },
  computed: {
    minDate() {
      const today = new Date();
      const currentDate = today.getDate();
      let [currentYear, currentMonth] = [new Date().getFullYear(), new Date().getMonth()];
      
      if (currentDate <= 9) {
        if (currentMonth === 0) {
          currentMonth = 11;
          currentYear--;
        } else {
          currentMonth--;
        }
        return new Date(currentYear, currentMonth, 1);
      }
      return new Date(currentYear, currentMonth + 1, 1);
    },
    maxDate() {
      const today = new Date();
      return new Date(today.getFullYear() + 1, today.getMonth(), 1);
    },
    repId(){
      return this.$store.getters.repId;
    },
    
  },
  watch: {
    data: {
      handler(newVal) {
        this.form.split_from_agent_id = newVal.from_rep.id;
        this.form.split_to_agent_id = newVal.to_rep.id;
        this.form.seller_agent_id = newVal.seller_reps.id;
        this.form.split_from_comm = newVal.split.from.replace('%', ''); 
        this.form.split_to_comm = newVal.split.to.replace('%', ''); 
        this.form.effective_date = newVal.effective_date;
        this.form.isActive = newVal.status === 'Enable' ? 1 : 0;
        this.seller_agent = {
          "agent_id": newVal.seller_reps.id,
          "agent_name": newVal.seller_reps.name + ' [' + newVal.seller_reps.code + ']',
        }
      },
      deep: true,
    },
     'form.split_from_comm': {
      handler(newVal) {
        if (newVal !== '' && !isNaN(newVal)) {
          const fromValue = parseFloat(newVal);
          if (fromValue >= 0 && fromValue <= 100) {
            this.form.split_to_comm = (100 - fromValue).toFixed(0);
            this.clearError('split_from_comm');
            this.clearError('split_to_comm');
          }
        }
      },
      immediate: true
    },
    'form.split_to_comm': {
      handler(newVal) {
        if (newVal !== '' && !isNaN(newVal)) {
          const toValue = parseFloat(newVal);
          if (toValue >= 0 && toValue <= 100) {
            this.form.split_from_comm = (100 - toValue).toFixed(0);
            this.clearError('split_from_comm');
            this.clearError('split_to_comm');
          }
        }
      },
      immediate: true
    },
  },
};
</script>
<style>
.w-fit ,.w-fit:focus{
  width: 80px;
  max-width: 80px;
}
.required {
  color: red;
}
.form-input {
  max-width: 100% !important;
}
.cancel-btn {
  background-color: #6c757d !important;
  color: #fff !important;
  border-radius: 6px;
}
.sub-header {
  font-weight: 600;
  font-size: 14px;
}
.cancel-btn .v-btn__content {
  color: #fff !important;
}
#add-modal .modal-body{
  padding-top: 0 !important;
}
.from-rep{
  background: #f5f5f5;
  border: 1px solid #ddd;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  border-radius: 0.25rem;
}
</style>
